<ll-titulo>Estadísticas</ll-titulo>

<estadisticas-multiples-profesor [evaluacionTipo]="tipoInstrumento"></estadisticas-multiples-profesor>
